import { render, staticRenderFns } from "./RuleGoEditor.vue?vue&type=template&id=567b6e05"
import script from "./RuleGoEditor.vue?vue&type=script&lang=js"
export * from "./RuleGoEditor.vue?vue&type=script&lang=js"
import style0 from "./RuleGoEditor.vue?vue&type=style&index=0&id=567b6e05&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports